import Row from '../../../Common/Row';
import Inputs from '../../../Inputs';
import Typography from '../../../../kingpin/atoms/Typography';
import React from 'react';

const EntityFiltersToggle = ({
  isEntityFiltersDisabled,
  setIsEntityFiltersDisabled,
}: {
  isEntityFiltersDisabled: boolean;
  setIsEntityFiltersDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Row centerAlign>
      <div style={{ marginRight: 8 }}>
        <Inputs.Toggle
          testId={'toggle-entity-filter'}
          value={isEntityFiltersDisabled !== true}
          onChange={(v) => setIsEntityFiltersDisabled(v !== true)}
        />
      </div>
      <div style={{ marginRight: 8 }}>
        <Typography.Body type="Label">Use Entity Filters</Typography.Body>
      </div>
    </Row>
  );
};

export default EntityFiltersToggle;
